import colors from '@/config/colors';
import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  fullHeight: {
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  container: {
    flex: 1,
    flexDirection: 'column',
    paddingVertical: 10,
    alignItems: 'center',
    width: 550,
  },
  title: {
    fontWeight: '600',
    fontSize: 22,
    paddingBottom: 10,
    textAlign: 'center',
  },
  formatWarning: {
    justifyContent: 'flex-start',
    marginTop: 10,
    marginRight: 20,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
  },
  cardContainer: {
    backgroundColor: '#FFFFFF',
    padding: 20,
    borderColor: colors.mediumGrey,
    borderRadius: 10,
    borderWidth: 1,
    flexDirection: 'column',
    justifyContent: 'flex-start',
    marginTop: 20,
    width: 550,
  },
  inputBoxContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 15,
    marginTop: 10,
  },
  inputBox: {
    paddingTop: 10,
    maxHeight: 70,
    minWidth: 320,
    backgroundColor: '#F8F8F8',
    borderBottomColor: '#555555',
    borderBottomWidth: 4,
  },
  inputText: {
    fontSize: 27,
    fontWeight: '400',
    textAlign: 'left',
    paddingVertical: 1,
    paddingHorizontal: 2,
    color: colors.black,
  },
  inputBorderError: {
    borderBottomWidth: 4,
    borderBottomColor: 'rgb(221, 44, 0)',
  },
  inputBorderAccepted: {
    borderBottomWidth: 4,
    borderBottomColor: '#51BF92',
  },
  digaCodeList: {
    fontSize: 18,
    paddingVertical: 10,
  },
  emailPopUp: {
    color: '#51BF92',
    fontWeight: '700',
  },
  bold: {
    fontWeight: '700',
  },
  information: {
    fontWeight: '400',
    fontSize: 20,
  },
  digaWrapper: {
    flexDirection: 'column',
    marginVertical: 10,
  },
  listWrapper: {
    flexDirection: 'column',
    marginVertical: 10,
  },
  errorWrapper: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: '12%',
  },
  errorInternetHeader: {
    fontSize: 26,
    fontWeight: '700',
  },
  errorInternetSubtitle: {
    fontSize: 18,
    fontWeight: '500',
  },
  errorInternetLink: {
    fontSize: 24,
    fontWeight: '700',
    color: '#91C1DE',
  },
  cardLabel: {
    fontWeight: '600',
    fontSize: 18,
  },
  secondInfoText: {
    fontSize: 18,
    marginTop: 10,
  },
  icon: { marginRight: 5, fontSize: 24, color: colors.primary },
  validCodesContainer: {
    borderColor: colors.primaryBrighter,
    borderRadius: 30,
    borderWidth: 2,
    padding: 20,
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 20,
    width: '100%',
  },
  validCodesText: {
    fontSize: 18,
    fontWeight: '700',
    marginTop: 10,
    color: colors.primary,
    textAlign: 'center',
  },
});
